import {Pipe, PipeTransform} from '@angular/core';
import * as tinycolor from 'tinycolor2';

@Pipe({
  name: 'textColor'
})

export class TextColorPipe implements PipeTransform {
  transform(col: string): string {
    return tinycolor(col).isLight() ? '#000' : '#fff';
  }
}
